// Current-page state for the shared nav partial (see src/_includes/_nav.html).
// The partial is static (posthtml-include has no parameters), so the
// current section is derived from the URL: deepest matching section wins,
// which keeps case studies under Work and app pages under Apps.
const links = document.querySelectorAll(".site-nav-link");
if (links.length > 0) {
  const path = window.location.pathname;
  let current = "/";
  links.forEach((link) => {
    const href = link.getAttribute("href");
    if (href !== "/" && path.startsWith(href) && href.length > current.length) {
      current = href;
    }
  });
  links.forEach((link) => {
    if (link.getAttribute("href") === current) {
      link.setAttribute("aria-current", "page");
    }
  });
}
